<v-app><v-main><router-view :key="$route.fullPath"></router-view></v-main></v-app>